
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import StackedForm from '../../mixins/StackedForm';
import { Tag } from '@/interfaces/models/Tag';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '../shared/form/VFormBuilder.vue';

@Component({
  components: { VFormBuilder },
})
export default class MassActiveForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  @Prop({ type: Array, required: true }) public tags!: Tag[];
  @Prop({ type: String, required: true }) public mode!: 'tag' | 'range';

  get items() {
    return [
      {
        name: 'isActive',
        type: InputType.Checkbox,
        default: false,
        label: 'table.form.isActive',
      },
      ...(this.mode === 'tag'
        ? [
            {
              name: 'tag',
              type: InputType.Select,
              label: 'table.form.tag',
              items: this.tagItems,
              rules: 'required',
            },
          ]
        : [
            {
              name: 'start',
              type: InputType.Text,
              label: 'table.form.start',
              rules: (form: any) => `required|smaller_than:${form.end}|integer|min:1`,
            },
            {
              name: 'end',
              type: InputType.Text,
              label: 'table.form.end',
              rules: (form: any) => `required|greater_than:${form.start}|integer|min:1`,
            },
          ]),
    ];
  }

  get tagItems() {
    return this.tags.map((t: Tag) => {
      return {
        value: t._id,
        text: this.$options.filters!.localized(t.name),
      };
    });
  }
}
